import React, { ChangeEvent, FunctionComponent,useRef,useState } from 'react'
import { Modal,Button,Col,Row, Tab, Form, Dropdown, FormLabel, FormControl} from 'react-bootstrap'
import PropTypes,{InferProps} from 'prop-types'
import SankeyEdition from 'open-sankey/dist/SankeyEdition'
import SankeyDraw from 'open-sankey/dist/SankeyDraw'
import parse from 'html-react-parser'
import { SankeyData, SankeyDataPropTypes,SankeyLink, SankeyNode } from './types'
import SankeyLinkContextMenu from 'open-sankey/dist/SankeyLinkContextMenu'
import SankeyNodeContextMenu from 'open-sankey/dist/SankeyNodeContextMenu'
import Menu from 'open-sankey/dist/SankeyMenu'
import { uploadExemple,toPrecision,set_nodes_level } from 'open-sankey/dist/SankeyUtils'
import { SankeySettingsEdition, SankeySettingsEditionTags } from 'open-sankey/dist/SankeySettingsEdition'
import SankeyNodeEdition from 'open-sankey/dist/SankeyNodeEdition'
import SankeyLinkEdition from 'open-sankey/dist/SankeyLinkEdition'
import { convert_data } from 'open-sankey/dist/SankeyConvert'
import { compute_auto_sankey,compute_default_input_outputLinksId,reorganize_node_inputLinksId,reorganize_node_outputLinksId,updateLayout,apply_input_outputLinksId } from 'open-sankey/dist/SankeyLayout'
import SankeyBannerMenu from './SankeyBannerMenu'
import * as SankeyUncert from './SankeyUncert'
import { linkTooltipsContent, nodeTooltipsContent } from './SankeyTooltip'
import { arrangeTrade, split_trade } from './SankeyTrade'
import * as d3 from 'd3'

const SankeyAppPropTypes = {
  initial_sankey_data: PropTypes.shape(SankeyDataPropTypes).isRequired
}

type SankeyAppTypes = InferProps<typeof SankeyAppPropTypes>

declare const window: Window &
typeof globalThis & {
  SankeyToolsStatic: boolean
  sankey: {
    sankey_data_file:RequestInfo
    sous_filieres : { [ key : string ] : string }
    units: string[],
    flask_logo? : string,
    flask_header? : string,
    logo_width? : number,
    legend_average : string,
    legend_uncert : string,
    welcome_text? : string,
    help_text : string
    excel : string
  }
}
const default_node = () : SankeyNode => {
  return {
    idNode       : 'node0',
    name         : 'node0',
    type         : 'sector',
    node_visible : true,
    shape_visible: true,
    label_visible: true,
    display      : true,
    color        : 'darkgrey',
    nodeParameter:'Général',
    x            : 100,
    y            : 100,
    inputLinksId  : [],
    outputLinksId : [],
    tags         : {},
    colorFavoriteTags:{},
    trade_height : 20,
    trade_width  : 50,
    trade_close  : false,
    dimensions   : {'Primaire' : {parent_name: undefined}}
  }
}

const default_link = () : SankeyLink => {
  return {
    idLink            : 'link0',
    idSource          : '',
    idTarget          : '',
    value             : [10],
    display_value     : ['default'],
    color             : 'darkgrey',
    curved            : false,
    arrow             : true,
    text_color        : 'black',
    label_position    : 'middle',
    curvature         : 0.5,
    label_visible     : true,
    label_on_path     : true,
    orientation       : 'hh',
    left_horiz_shift  : 0,
    right_horiz_shift : 0,
    vert_shift        : 0,
    shift_gap         : 0.05,
    tooltip_text      : null,
    tags              : {}
  }
}

export const SankeyApp : FunctionComponent<SankeyAppTypes> = ({initial_sankey_data}) => {
  const [show_publish_dialog,set_show_publish_dialog] = useState(false)
  const [show_split_trade_dialog,set_show_split_trade_dialog] = useState(false)
  const [show_nav, set_show_nav] = useState(false)
  const [nav_item_active, set_nav_item_active] = useState<string>('')
  const [show_node_context,set_show_node_context] = useState(false)
  const [show_link_context,set_show_link_context] = useState(false)
  const [selected_link,set_selected_link] = useState(default_link())
  const [selected_node,set_selected_node] = useState(default_node())
  const [selected_id_link, set_selected_id_link] = useState<string>('')
  const set_default_tooltip = useState(true)[1]
  const [data,set_data] = useState<SankeyData>(initial_sankey_data)
  const [welcome_text,set_welcome_text] = useState(window.sankey ? window.sankey.welcome_text : undefined)
  const [show_excel_dialog, set_show_excel_dialog] = useState(false)
  const [trade_width,set_trade_width] = useState(initial_sankey_data.trade_close_hspace)
  const [trade_close,set_trade_close] = useState(false)
  const [radio_selected, set_radio_selected] = useState<string>('local')
  const [agregation_level,set_agregation_level] = useState(0)

  const getValueIndex = (
    data: SankeyData 
  ) => {
    let region_index = 0
    const regions_tags_group = data.tags_catalog['Regions']
    if (regions_tags_group) {
      Object.entries(regions_tags_group.tags).forEach((tag,i)=> {
        if (tag[1].selected) {
          region_index = i
        }
      })
    }
    let period_index = 0
    const periods_tags_group = data.tags_catalog['Periods']
    if (periods_tags_group) {
      Object.entries(periods_tags_group.tags).forEach((tag,i)=> {
        if (tag[1].selected) {
          period_index = i
        }
      })
      return region_index * Object.keys(periods_tags_group).length + period_index  
    }
    return region_index
  }

  const link_text = (
    d: SankeyLink,
    link_value: number,
    display_style: { font_size?: string; filter?: number; filter_label?: number; unit?: boolean },
    reg_index: number
  ) => {
    const str_display = String(d.display_value[reg_index])
    if (str_display !== 'default' && !str_display.includes('[')) {
      if (str_display.includes('[')) {
        return 
      }
      return str_display
    }
    
    const the_link_value = toPrecision(link_value)
    if (display_style.unit && d.conv && d.natural_unit) {
      return toPrecision(the_link_value*d.conv[1]) + ' ' + d.natural_unit.replace('k tonnes','kt').replace('k tonne','kt')
    } else {
      return the_link_value
    }
  }

  const link_visible = (l : SankeyLink) => {
    if (!data.nodes[l.idSource].node_visible || !data.nodes[l.idTarget].node_visible ) {
      return false
    }
    const value_index = getValueIndex(data)

    const uncert_group = data.tags_catalog['Uncert']
    if (uncert_group) {
      if (l.tags['Uncert']) { 
        if ( !data.tags_catalog['Uncert'].tags[l.tags['Uncert'][0]].selected ) {
          return false
        }
      }
    }

    const flux_types_group = data.tags_catalog['flux_types']
    if ( flux_types_group === undefined) {
      if ( data.display_style.null_flux ) {
        return true
      }
      if (l.value[value_index] === 0 ) {
        return false
      }
      return true    
    }

    const tag_initial_data  = flux_types_group.tags['initial_data']
    const tag_adjusted_data = flux_types_group.tags['adjusted_data']
    const data_selected = tag_initial_data.selected || tag_adjusted_data.selected

    const tag_computed_data = flux_types_group.tags['computed_data']
    const only_data_selected = data_selected && !tag_computed_data.selected
    const only_computed_selected = !data_selected && tag_computed_data.selected
    const both_computed = data_selected && tag_computed_data.selected

    if (both_computed) {
      if ( data.display_style.null_flux ) {
        return true
      }
      if (l.value[value_index] === 0 ) {
        return false
      }
      return true
    } else if ( only_data_selected ) {
      if ( l.data_value === null || l.data_value === undefined ) {
        return false
      }
      if ( data.display_style.null_flux ) {
        return true
      }
      if (tag_initial_data.selected && l.data_value[value_index] === 0 ) {
        return false
      } else if (tag_adjusted_data.selected && l.value[value_index] === 0 ) {
        return false
      }
      return true
    } else if ( only_computed_selected ) {
      if ( l.data_value !== null && l.data_value !== undefined ) {
        return false
      }
      if ( data.display_style.null_flux ) {
        return true
      }
      if (l.value[value_index] === 0 ) {
        return false
      }
      return true            
    }
  }

  const node_arrow_visible = (n : SankeyNode) => {
    if (!n.node_visible) {
      return false
    }
    if ( n.inputLinksId.length === 0 ) {
      return false
    }
    if (n.trade_close && n.tags['Exchanges'] !== undefined && n.tags['Exchanges'].includes('Exportations') ) {
      return false
    }
    if ( !data.links[n.inputLinksId[0]].arrow ) {
      return false
    }

    return true
  }

  const test_link_value = (
    nodes : { [node_id : string]:SankeyNode},
    link: SankeyLink
  ) => {
    const value_index = getValueIndex(data)

    const flux_types_group = data.tags_catalog['flux_types']

    //const link_default_width = 5

    const source_node = nodes[link.idSource]
    const target_node = nodes[link.idTarget]
    // Sanity check
    if (source_node === undefined || target_node === undefined ) {
      return 0
    }
    if ( flux_types_group === undefined ) {
      return link.value[value_index]
    }

    const tag_initial_data  = flux_types_group.tags['initial_data']
    const tag_adjusted_data = flux_types_group.tags['adjusted_data']
    const tag_computed_data = flux_types_group.tags['computed_data']

    if (String(link.display_value[value_index]).includes('[') ) {
      return link.value[value_index]
    }
    if (String(link.display_value[value_index]).includes('*') ) {
      return link.value[value_index]
    }
    if ( tag_initial_data.selected && link.tags['flux_types'].includes('initial_data') && link.data_value !== undefined && link.data_value !== null) {
      return link.data_value[value_index]
    }
    if ( tag_adjusted_data.selected && link.tags['flux_types'].includes('adjusted_data') ||
         tag_computed_data.selected && link.tags['flux_types'].includes('computed_data')
    ) {
      return link.value[value_index]
    }
    return link.value[value_index]
  }

  const uploadExcelImpl = (
    input_file : Blob[],
    sheet: string
  ) => {
    const form_data = new FormData()
    form_data.append('file', input_file[0])

    const path = window.location.href

    let url = path + 'sankey/upload_data'
    if (sheet == 'data') {
      url = path + 'sankey/upload_input_excel_data'
    }
    const fetchData = {
      method: 'POST',
      body: form_data
    }
    const callback = (server_data: SankeyData & { error: string }) => {
      const error = server_data['error']
      if (error && error.length != 0) {
        alert(error)
        return
      }
      Object.assign(data, server_data)
      convert_data(data)
      compute_auto_sankey(data, 200)
      set_data({ ...data })
    }
    fetch(url, fetchData).then(response => {
      response.text().then(text => {
        // try {
        const json_data = JSON.parse(text)
        callback(json_data)
        // } catch(err) {
        //   alert(err)
        // }
      })
    })
    set_show_excel_dialog(false)
  }

  const publishImpl = (
    input_file_name : string
  ) =>{
    const form_data = new FormData()
    form_data.append('file_name', input_file_name)
    form_data.append('data',JSON.stringify(data, null, 3))

    const path = window.location.href

    const url = path + 'sankey/publish'
    const fetchData = {
      method: 'POST',
      body: form_data
    }

    fetch(url, fetchData).then( response => {
      if (!response.ok) {
        response.text().then(text =>  alert(text))
      }
    })
    set_show_publish_dialog(false)
  }

  const scale = d3.scaleLinear()
    .domain([0, +data.user_scale])
    .range([0, 100])

  const file_path = data.file_path
  
  return (
    <div style={{ 'backgroundColor' : 'WhiteSmoke' }}>
      { !window.SankeyToolsStatic ? (
        <Menu 
          data={data} 
          set_data={set_data}
          open_menu = {
            <Dropdown.Item 
              onClick={ () => set_show_excel_dialog(true) }
            >Excel AFM</Dropdown.Item>               
          }
          edition_menu = {
            <>
              <Dropdown.Item 
                onClick={ () => set_show_publish_dialog(true) }
              >Publier</Dropdown.Item>   
              <Dropdown.Item 
                onClick={ () => set_show_split_trade_dialog(true) }
              >Individualiser Import/Export</Dropdown.Item>
            </>                        
          }
          app_name='AFM-Sankey'
          set_show_nav={set_show_nav}
          show_nav={show_nav}
          set_nav_item_active={set_nav_item_active}
          nav_item_active={nav_item_active}
          right_menu = {
            <Form.Switch 
              id="custom-switch"
              label="Mode Publication"
              onChange={() => {
                data.static_sankey = !data.static_sankey
                set_data({...data})
              }}
            />
          }
          example_menu= {
            <>
              <Dropdown.Item onClick={() => uploadExemple(
                'pommes_poires.xlsx', '', data, set_data, 
                (server_data : SankeyData)=>compute_auto_sankey(server_data, server_data.h_space ? server_data.h_space : 200)
              )} >Pommes Poires AFM</Dropdown.Item>
              <Dropdown.Item onClick={()=>uploadExemple(
                'filiere_foret_bois_savoie.xlsx', '', data, set_data,
                (server_data : SankeyData)=> {
                  server_data.links['link371'].idSource = 'node63'
                  delete server_data.links['link372']
                  compute_default_input_outputLinksId(server_data.nodes, server_data.links)
                  const trade_sectors = [
                    'Hors Pays de Savoie - Importations',
                    'Hors Pays de Savoie - Exportations',
                    'International - Importations',
                    'International - Exportations',
                    'Autres régions françaises - Importations',
                    'Autres régions françaises - Exportations'
                  ];
                  (trade_sectors as string[]).forEach( (trade_sector:string, i:number) => {
                    split_trade(trade_sector,i,data)
                  })
                  server_data.tags_catalog['Exchanges'].tags['Hors Pays de Savoieimport'].selected = true
                  server_data.tags_catalog['Exchanges'].tags['Hors Pays de Savoieexport'].selected = true
                  let nb_agregation_level = 0
                  Object.values(data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
                  for (let i=1 ; i<=nb_agregation_level ; i++) {
                    set_nodes_level(server_data.nodes,i)
                    updateLayout(server_data, (server_data as SankeyData & { layout: SankeyData }).layout)
                  }
                  // Object.values(server_data.nodes).forEach(function (n) {
                  //   reorganize_node_inputLinksId(n, server_data.nodes, server_data.links)
                  //   reorganize_node_outputLinksId(n, server_data.nodes, server_data.links)
                  // })
                  apply_input_outputLinksId(
                    (server_data as SankeyData & { layout: SankeyData }).layout.nodes,
                    (server_data as SankeyData & { layout: SankeyData }).layout.links,
                    server_data
                  )
                  delete (server_data as SankeyData & { layout?: SankeyData }).layout
                  set_nodes_level(server_data.nodes,1)                
                }
              )} >Forêt-Bois Savoie AFM</Dropdown.Item>
              <Dropdown.Item onClick={()=>uploadExemple(
                'filiere_foret_bois_deux_savoies.xlsx', '', data, set_data,
                (server_data : SankeyData)=> {
                  compute_default_input_outputLinksId(server_data.nodes, server_data.links)
                  const trade_sectors = [
                    'Hors Pays de Savoie - Importations',
                    'Hors Pays de Savoie - Exportations',
                    'International - Importations',
                    'International - Exportations',
                    'Autres régions françaises - Importations',
                    'Autres régions françaises - Exportations'
                  ];
                  (trade_sectors as string[]).forEach( (trade_sector:string, i:number) => {
                    split_trade(trade_sector,i,data)
                  })
                  server_data.tags_catalog['Exchanges'].tags['Hors Pays de Savoieimport'].selected = true
                  server_data.tags_catalog['Exchanges'].tags['Hors Pays de Savoieexport'].selected = true
                  let nb_agregation_level = 0
                  Object.values(data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
                  for (let i=1 ; i<=nb_agregation_level ; i++) {
                    set_nodes_level(server_data.nodes,i)
                    updateLayout(server_data, (server_data as SankeyData & { layout: SankeyData }).layout)
                  }
                  // Object.values(server_data.nodes).forEach(function (n) {
                  //   reorganize_node_inputLinksId(n, server_data.nodes, server_data.links)
                  //   reorganize_node_outputLinksId(n, server_data.nodes, server_data.links)
                  // })
                  apply_input_outputLinksId(
                    (server_data as SankeyData & { layout: SankeyData }).layout.nodes,
                    (server_data as SankeyData & { layout: SankeyData }).layout.links,
                    server_data
                  )
                  delete (server_data as SankeyData & { layout?: SankeyData }).layout
                  set_nodes_level(server_data.nodes,1)                
                }
              )} >Forêt-Bois Savoie AFM v2</Dropdown.Item>
              <Dropdown.Item onClick={()=>uploadExemple(
                'filiere_foret_bois_grand_est.xlsx', '', data, set_data,
                (server_data : SankeyData)=> {
                  // server_data.links['link371'].idSource = 'node63'
                  // delete server_data.links['link372']
                  compute_default_input_outputLinksId(server_data.nodes, server_data.links)
                  const trade_sectors = [
                    'Reste du monde - Importations',
                    'Reste du monde - Exportations',
                    'International - Importations',
                    'International - Exportations',
                    'Autres régions françaises - Importations',
                    'Autres régions françaises - Exportations'
                  ];
                  (trade_sectors as string[]).forEach( (trade_sector:string, i:number) => {
                    split_trade(trade_sector,i,data)
                  })
                  server_data.tags_catalog['Exchanges'].tags['Reste du mondeimport'].selected = true
                  server_data.tags_catalog['Exchanges'].tags['Reste du mondeexport'].selected = true
                  let nb_agregation_level = 0
                  Object.values(data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
                  for (let i=1 ; i<=nb_agregation_level ; i++) {
                    set_nodes_level(server_data.nodes,i)
                    updateLayout(server_data, (server_data as SankeyData & { layout: SankeyData }).layout)
                  }
                  // Object.values(server_data.nodes).forEach(function (n) {
                  //   reorganize_node_inputLinksId(n, server_data.nodes, server_data.links)
                  //   reorganize_node_outputLinksId(n, server_data.nodes, server_data.links)
                  // })
                  apply_input_outputLinksId(
                    (server_data as SankeyData & { layout: SankeyData }).layout.nodes,
                    (server_data as SankeyData & { layout: SankeyData }).layout.links,
                    server_data
                  )
                  // Object.values(server_data.links).forEach(l=>{
                  //   l.curved = true
                  //   const center = (l.left_horiz_shift+l.right_horiz_shift)/2
                  //   l.left_horiz_shift  = center - 0.05
                  //   l.right_horiz_shift = center + 0.05  
                  //   l.shift_gap = 0.05
                  // })
                  delete (server_data as SankeyData & { layout?: SankeyData }).layout
                  set_nodes_level(server_data.nodes,1)                
                }
              )} >Forêt-Bois Grand Est AFM</Dropdown.Item>
              <Dropdown.Item onClick={()=>uploadExemple(
                'filiere_viande.xlsx', '', data, set_data,
                (server_data : SankeyData)=> {
                  compute_default_input_outputLinksId(server_data.nodes, server_data.links)
                  const trade_sectors = [
                    'Reste du monde - Importations',
                    'Reste du monde - Exportations',
                  ];
                  (trade_sectors as string[]).forEach( (trade_sector:string, i:number) => {
                    split_trade(trade_sector,i,data)
                  })
                  server_data.tags_catalog['Exchanges'].tags['Reste du mondeimport'].selected = true
                  server_data.tags_catalog['Exchanges'].tags['Reste du mondeexport'].selected = true
                  let nb_agregation_level = 0
                  Object.values(data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
                  for (let i=1 ; i<=3 ; i++) {
                    set_nodes_level(server_data.nodes,i)
                    updateLayout(server_data, (server_data as SankeyData & { layout: SankeyData }).layout)
                  }
                  Object.values(server_data.nodes).forEach(function (n) {
                    reorganize_node_inputLinksId(n, server_data.nodes, server_data.links)
                    reorganize_node_outputLinksId(n, server_data.nodes, server_data.links)
                  })
                  // apply_input_outputLinksId(
                  //   (server_data as SankeyData & { layout: SankeyData }).layout.nodes,
                  //   (server_data as SankeyData & { layout: SankeyData }).layout.links,
                  //   server_data
                  // )
                  // Object.values(server_data.links).forEach(l=>{
                  //   l.curved = true
                  //   const center = (l.left_horiz_shift+l.right_horiz_shift)/2
                  //   l.left_horiz_shift  = center - 0.05
                  //   l.right_horiz_shift = center + 0.05  
                  //   l.shift_gap = 0.05
                  // })
                  delete (server_data as SankeyData & { layout?: SankeyData }).layout
                  set_nodes_level(server_data.nodes,1)                
                }
              )} >Viande nationale et régionale AFM</Dropdown.Item>
              <Dropdown.Item onClick={()=>uploadExemple(
                'filiere_lait.xlsx', '', data, set_data,
                (server_data : SankeyData)=> {
                  compute_default_input_outputLinksId(server_data.nodes, server_data.links)
                  const trade_sectors = [
                    'Echanges - Importations',
                    'Echanges - Exportations',
                  ];
                  (trade_sectors as string[]).forEach( (trade_sector:string, i:number) => {
                    split_trade(trade_sector,i,data)
                  })
                  server_data.tags_catalog['Exchanges'].tags['Echangesimport'].selected = true
                  server_data.tags_catalog['Exchanges'].tags['Echangesexport'].selected = true
                  let nb_agregation_level = 0
                  Object.values(data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
                  for (let i=1 ; i<=3 ; i++) {
                    set_nodes_level(server_data.nodes,i)
                    updateLayout(server_data, (server_data as SankeyData & { layout: SankeyData }).layout)
                  }
                  Object.values(server_data.nodes).forEach(function (n) {
                    reorganize_node_inputLinksId(n, server_data.nodes, server_data.links)
                    reorganize_node_outputLinksId(n, server_data.nodes, server_data.links)
                  })
                  // apply_input_outputLinksId(
                  //   (server_data as SankeyData & { layout: SankeyData }).layout.nodes,
                  //   (server_data as SankeyData & { layout: SankeyData }).layout.links,
                  //   server_data
                  // )
                  // Object.values(server_data.links).forEach(l=>{
                  //   l.curved = true
                  //   const center = (l.left_horiz_shift+l.right_horiz_shift)/2
                  //   l.left_horiz_shift  = center - 0.05
                  //   l.right_horiz_shift = center + 0.05  
                  //   l.shift_gap = 0.05
                  // })
                  delete (server_data as SankeyData & { layout?: SankeyData }).layout
                  set_nodes_level(server_data.nodes,1)                
                }
              )} >Lait national et régional AFM</Dropdown.Item>
            </>
          }
          set_selected_id_link={set_selected_id_link}
          selected_id_link={selected_id_link}
          set_selected_node={set_selected_node}
          selected_node={selected_node}
          set_selected_link={set_selected_link}
          selected_link={selected_link}
          radio_selected={radio_selected}
          set_radio_selected={set_radio_selected}
          agregation_level={agregation_level}
          set_agregation_level={set_agregation_level}
          url_prefix='/opensankey/'
          getValueIndex={getValueIndex}
          settings_edition= {
            <SankeySettingsEdition
              data={data}
              set_data={set_data}
              set_current_filter={(
                new_current_filter: number
              ) => {
                const { display_style } = data
                display_style.filter = +new_current_filter
                set_data({ ...data })
              }}
              getValueIndex={getValueIndex}
            >
              <Tab eventKey="trade" title="Echanges">
                <br></br>
                <Form >
                  <Form.Group as={Row} >
                    <Col>
                      <Form.Check  
                        type='checkbox'
                        label='Prés du noeud'
                        checked = {trade_close}
                        onChange = {evt => { 
                          Object.values(data.nodes).forEach(n=>n.trade_close = evt.target.checked)
                          set_trade_close(evt.target.checked)
                          set_data({...data}) 
                        }}
                      />
                    </Col>
                    <Col>
                      <Button  onClick={()=> {
                        arrangeTrade(data,scale,getValueIndex)
                        set_data({...data})
                      }}>
                        Arranger
                      </Button>
                    </Col>
                  </Form.Group>
                  <hr/>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel >Décalage horizontal</FormLabel>
                    </Col>
                    <Col>
                      <Form.Range
                        min="0" max="200"
                        value={data.trade_close_hspace}
                        onChange={
                          evt => {
                            data.trade_close_hspace = +evt.target.value
                            set_data({ ...data })
                          }
                        }
                      />
                    </Col>
                    <Col>{data.trade_close_hspace}</Col>
                  </Form.Group>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel>Décalage vertical</FormLabel>
                    </Col>
                    <Col>
                      <Form.Range
                        min="0" max="200"
                        value={data.trade_close_vspace}
                        onChange={
                          evt => {
                            data.trade_close_vspace = +evt.target.value
                            set_data({ ...data })
                          }
                        }
                      />
                    </Col>
                    <Col>{data.trade_close_vspace}</Col>
                  </Form.Group>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel>Décalage horizontal</FormLabel>
                    </Col>
                    <Col>
                      <Form.Range
                        min="0" max="400"
                        value={data.trade_hspace}
                        onChange={
                          evt => {
                            data.trade_hspace = +evt.target.value
                            set_data({ ...data })
                          }
                        }
                      />
                    </Col>
                    <Col>{data.trade_hspace}</Col>
                  </Form.Group>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel>Position du point de controle source</FormLabel>
                    </Col>
                    <Col>
                      <Form.Range
                        min="0" max="100"
                        value={data.trade_left_shift*100}
                        onChange={
                          evt => {
                            const trade_left_shift = (+evt.target.value)/100
                            if ( trade_left_shift < data.trade_right_shift) {
                              data.trade_left_shift = (+evt.target.value)/100
                            }
                            set_data({ ...data })
                          }
                        }
                      />
                    </Col>
                    <Col>{data.trade_left_shift}</Col>
                  </Form.Group>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel>Position du point de controle destination</FormLabel>
                    </Col>
                    <Col>
                      <Form.Range
                        min="0" max="100"
                        value={data.trade_right_shift*100}
                        onChange={
                          evt => {
                            const trade_right_shift = (+evt.target.value)/100
                            if ( data.trade_left_shift < trade_right_shift) {
                              data.trade_right_shift = (+evt.target.value)/100
                            }
                            set_data({ ...data })
                          }
                        }
                      />
                    </Col>
                    <Col>{data.trade_right_shift}</Col>
                  </Form.Group>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel>Ecart maximum entre points de controle</FormLabel>
                    </Col>
                    <Col>
                      <Form.Range
                        min="0" max="50"
                        value={data.trade_max_shift*100}
                        onChange={
                          evt => {
                            data.trade_max_shift = (+evt.target.value)/100
                            set_data({ ...data })
                          }
                        }
                      />
                    </Col>
                    <Col>{data.trade_max_shift}</Col>
                  </Form.Group>
                </Form>
              </Tab>
            </SankeySettingsEdition>
          }
          node_edition= {
            <SankeyNodeEdition
              data={data}
              set_data={set_data}
              selected_node={selected_node}
              radio_selected={radio_selected}
              getValueIndex={getValueIndex}
            >
              <Tab eventKey="exchanges" title="Echanges">
                <br></br>
                <Form >
                  <Form.Group as={Row} >
                    <Col>
                      <Form.Check  
                        type='checkbox'
                        label='Prés du noeud'
                        checked = {selected_node.trade_close }
                        onChange = {evt => { 
                          selected_node.trade_close = evt.target.checked
                          set_data({...data}) 
                        }}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} >
                    <Col>
                      <FormLabel >Width</FormLabel>
                    </Col>
                    <Col>
                      <FormControl
                        type="text"
                        value={selected_node.trade_width}
                        onChange={evt => set_trade_width(+evt.target.value)}
                        onBlur={() => {
                          selected_node.trade_width = trade_width
                          set_data({ ...data })
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Form>
              </Tab>
            </SankeyNodeEdition>
          }
          link_edition={
            <SankeyLinkEdition
              show={true}
              data={data}
              set_data={set_data}
              selected_link={selected_link}
              getValueIndex={getValueIndex}
            />
          }
          settings_edition_tags = {
            <SankeySettingsEditionTags
              data={data}
              set_data={set_data}
              getValueIndex={getValueIndex}
            />
          }
        >
        </Menu>
      ) : (<></>)}
      {data.static_sankey ? (
        <Row style={{ 'marginBottom': '30px' }}>
          <Col sm={11} style={{ 'color': 'black' }} >
            <SankeyBannerMenu
              sankey_data={data}
              set_sankey_data={set_data} 
              set_default_tooltip={set_default_tooltip}
            />
          </Col>
        </Row>
      ) : (<></>)}
      { !data.static_sankey ? (
        <Row>            
          <Col sm={11} style={{ 'color':'black'}} >
            <SankeyEdition 
              data={data} 
              set_selected_node={set_selected_node} 
              set_selected_link={set_selected_link} 
              default_link={default_link} 
              default_node={default_node} 
              set_data={set_data}/>
          </Col>
        </Row>
      ) : (<div/>)}
      <SankeyDraw 
        data={data}
        set_data={set_data}
        select_node={(n: SankeyNode) => {
          set_selected_node(n)
        }}
        //node_visible={(n : SankeyNode) => node_or_label_visible(n) && n.visible ? 'visible' : 'hidden'}
        //node_label_visible={(n : SankeyNode) => node_or_label_visible(n) && n.label_visible ? 'visible' : 'hidden'}
        node_arrow_visible={node_arrow_visible}
        nodeContextMenu={(n: SankeyNode)=> {
          set_selected_node(n)
          set_show_node_context(true)
        }}
        select_link={(l: SankeyLink) => {
          set_selected_link(l)
        }}
        linkContextMenu={(l: SankeyLink)=> {
          set_selected_link(l)
          set_show_link_context(true)
        }}
        link_color ={data.show_uncert ? SankeyUncert.uncert_link_color : (l:SankeyLink) => l.color }
        node_color = {data.show_uncert ? SankeyUncert.uncert_node_color : (n:SankeyNode) => n.color }
        link_text = {data.show_uncert ? SankeyUncert.uncert_link_text : link_text }
        link_visible = {link_visible}
        test_link_value = {test_link_value}
        nodeTooltipsContent={nodeTooltipsContent}
        linkTooltipsContent={linkTooltipsContent}
        set_show_nav={set_show_nav}
        set_nav_item_active={set_nav_item_active}
        set_selected_id_link={set_selected_id_link}
        selected_id_link={selected_id_link}
        getValueIndex={getValueIndex}
      />
 
      {/* <Tab eventKey="units" title="Unités" >
            <br></br>
            <Form.Group as={Row} >
              <FormLabel column sm={2}>Nb unités:</FormLabel>
              <Col sm={2}>
                <FormControl
                  type="text" value={nb_units}
                  //onChange={this.set_nb_units} 
                />
              </Col>

              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Unité naturelle</th>
                    <th>Coefficient de conversion</th>
                  </tr>
                </thead>
                <tbody>
                  {units.map(
                    (value,i) => { return(
                      <tr key={i.toString()}>
                        <td>
                          <FormControl 
                            id={i.toString()}
                            type="text"
                            value={value}
                            //onChange={this.set_unit_name}
                          />
                        </td>
                        <td> 
                          <FormCheck 
                            name={'element_visible'+i.toString()} 
                            defaultChecked={selected_tags.includes(value)}  
                            id={i.toString()}
                            type='checkbox' 
                            //onChange={this.set_natural_unit}
                          />
                        </td>
                        <td>
                          <FormControl 
                            id={i.toString()}
                            type="text"
                            value={value}
                            //onChange={this.set_unit_coeff}
                          />
                        </td>
                      </tr>
                    )})}
                </tbody>
              </Table>
            </Form.Group>
          </Tab> */}
      {/* </SankeySettingsEdition> */}
      <SankeyNodeContextMenu 
        data={data}
        set_data={set_data}
        show={show_node_context} 
        closeNodeContextMenu={() => set_show_node_context(false)} 
        selected_node={selected_node} 
      >
      </SankeyNodeContextMenu>
      <SankeyLinkContextMenu 
        data={data}
        set_data={set_data}
        show={show_link_context} 
        closeLinkContextMenu={() => set_show_link_context(false)} 
        selected_link={selected_link} />

      <Modal 
        bsSize="large" 
        show={welcome_text} 
        onHide={()=>{
          set_welcome_text(undefined)
        }}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Lisez Moi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {welcome_text ? parse(welcome_text) : ''}
          <Button 
            onClick={()=>{
              set_welcome_text(undefined)
            }}
          >J&apos;ai lu</Button>
        </Modal.Body>
      </Modal>
      { show_publish_dialog ?  (
        <PublishModal 
          handleCloseDialog = {()=>set_show_publish_dialog(false)}
          initial_file_path = {file_path}
          publishImpl = {publishImpl} />
      ) :
        (<div/>)
      }
      { show_split_trade_dialog ?  (
        <SplitVerticalModal 
          data = {data}
          initial_trade_node_names = {data.trade_sectors ? data.trade_sectors : [] }
          split_trade = {(trade_sectors : string[]) => {
            trade_sectors.forEach( (trade_sector, i) => {
              split_trade(trade_sector,i,data)
            })
            set_data({...data})
          }}
          set_show_split_trade = {set_show_split_trade_dialog} />
      ) :
        (<div/>)
      }
      {show_excel_dialog ? (
        <ExcelModal
          handleCloseDialog={()=>set_show_excel_dialog(false)}
          uploadExcelImpl={uploadExcelImpl} />
      ) :
        (<div />)
      }
    </div>
  )
}

SankeyApp.propTypes = SankeyAppPropTypes

export default SankeyApp

export const computeTotalOffsets = (
  node: SankeyNode,
  nodes: { [idNode:string]:SankeyNode},
  links: { [idLink:string]:SankeyLink},
  data_displayed: boolean,
  value_index: number
) =>{
  let total_output_offset = 0
  node.outputLinksId.forEach(
    (idLink) => {
      const link = links[idLink]
      if ( !nodes[link.idSource].node_visible || !nodes[link.idTarget].node_visible ) {
        return
      }
      if (data_displayed && link.tags['flux_types'].includes('initial_data') && link.data_value !== undefined && link.data_value !== null ) {
        total_output_offset += +link.data_value[value_index]
      } else {
        total_output_offset += +link.value[value_index]
      }
    }
  )
  let total_input_offset = 0
  node.inputLinksId.forEach(
    (idLink) => {
      const link = links[idLink]
      if ( !nodes[link.idSource].node_visible || !nodes[link.idTarget].node_visible ) {
        return
      }
      if (data_displayed && link.tags['flux_types'].includes('initial_data') && link.data_value !== undefined && link.data_value !== null ) {
        total_input_offset += +link.data_value[value_index]
      } else {
        total_input_offset += +link.value[value_index]         
      }
    }
  )
  return [total_input_offset,total_output_offset]
}

const PublishModalPropTypes = {
  initial_file_path : PropTypes.string.isRequired,
  publishImpl : PropTypes.func.isRequired,
  handleCloseDialog :PropTypes.func.isRequired
}

type PublishModalTypes = InferProps<typeof PublishModalPropTypes>

const PublishModal : FunctionComponent<PublishModalTypes> = ({initial_file_path,publishImpl,handleCloseDialog}) => {
  const [file_path,set_file_path] = useState<string>(initial_file_path)

  return (
    <Modal show={true} onHide={handleCloseDialog} >
      <Modal.Header closeButton>
        <Modal.Title>Ouvrir Fichier JSON</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Row>
              <Col>
                <Form.Label>
                  Fichier d&apos;entrée json
                </Form.Label>
              </Col>
              <Col>    
                <Form.Control
                  type="text"
                  value={file_path}
                  onChange={ evt => set_file_path(evt.target.value)}
                />
              </Col>
            </Row>      
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={()=>publishImpl(file_path)}>Publier</Button>
        <Button variant="secondary" onClick={handleCloseDialog}>Annuler</Button>
      </Modal.Footer>
    </Modal>)
}

PublishModal.propTypes = PublishModalPropTypes

const SplitVerticalModalPropTypes = {
  data : PropTypes.shape(SankeyDataPropTypes).isRequired,
  initial_trade_node_names : PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  split_trade : PropTypes.func.isRequired,
  set_show_split_trade :PropTypes.func.isRequired
}

type  SplitVerticalModalTypes = InferProps<typeof  SplitVerticalModalPropTypes>

const SplitVerticalModal : FunctionComponent<SplitVerticalModalTypes> = (
  {data,initial_trade_node_names,split_trade,set_show_split_trade}
) => {
  const [trade_node_names,set_trade_node_names] = useState(initial_trade_node_names)

  return (
    <Modal 
      show={true} 
      onHide={ () => set_show_split_trade(false) } >
      <Modal.Header closeButton>
        <Modal.Title>Noeuds Imports Exports</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Row>
              <Col>    
                <Form.Select multiple
                  onChange={evt=> {
                    const new_trade_nodes = []
                    for (let i=0;i<(evt.currentTarget as HTMLSelectElement).options.length;i++) {
                      if ( (evt.currentTarget as HTMLSelectElement).options[i].selected ) {
                        new_trade_nodes.push((evt.currentTarget as HTMLSelectElement).options[i].label)
                      }
                    }
                    data.trade_sectors = new_trade_nodes
                    set_trade_node_names(new_trade_nodes)
                  }}
                >
                  {Object.values(data.nodes).filter(
                    n => n.tags['Exchanges'] && !n.tags['Exchanges'].includes('Other') && n.name.split('-').length === 2
                  ).map(
                    (n, i) => <option key={i} value={n.name} selected={trade_node_names.includes(n.name)} >{n.name}</option>
                  )}
                </Form.Select>
              </Col>
            </Row>      
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={()=> {
            split_trade(data.trade_sectors)
            compute_default_input_outputLinksId(data.nodes,data.links)
            Object.values(data.nodes).forEach(function (n) {
              reorganize_node_inputLinksId(n, data.nodes, data.links)
              reorganize_node_outputLinksId(n, data.nodes, data.links)
            })
            set_show_split_trade(false)
          }}
        >Individualiser</Button>
        <Button variant="secondary" onClick={() => set_show_split_trade(false)}>Annuler</Button>
      </Modal.Footer>
    </Modal>)
}

SplitVerticalModal.propTypes = SplitVerticalModalPropTypes

const ExcelModalPropTypes = {
  uploadExcelImpl: PropTypes.func.isRequired,
  handleCloseDialog: PropTypes.func.isRequired
}

type ExcelModalTypes = InferProps<typeof ExcelModalPropTypes>

const ExcelModal: FunctionComponent<ExcelModalTypes> = ({ uploadExcelImpl, handleCloseDialog }) => {
  let input_file_name: Blob[] | undefined
  const [sheet, set_sheet] = useState('results')

  return (
    <Modal
      show={true}
      onHide={handleCloseDialog}
    >
      <Modal.Header closeButton>
        <Modal.Title>Ouvrir Fichier Excel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Row>
              <Col>
                <Form.Label>Fichier d&apos;entrée excel</Form.Label>
              </Col>
              <Col>
                <Form.Control
                  type="file"
                  onChange={(evt: ChangeEvent) => {
                    input_file_name = (evt.target as HTMLFormElement).files
                  }}
                /></Col>

            </Row>
            <Row>
              <Col>
                <Form.Label>Onglet</Form.Label>
              </Col>
              <Col sm={4}>
                <Form.Control as="select"
                  onChange={
                    evt => set_sheet((evt.target as HTMLInputElement).value)
                  }
                >
                  <option
                    key={0}
                    value='data'
                    selected={sheet === 'data'}
                  >Données</option>
                  <option
                    key={1}
                    value='results'
                    selected={sheet === 'results'}
                  >Résultats</option>
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={
            () => uploadExcelImpl(
              input_file_name,
              sheet
            )
          }
        >Ouvrir</Button>
        <Button
          variant="secondary"
          onClick={handleCloseDialog}
        >Annuler</Button>
      </Modal.Footer>
    </Modal>)
}

ExcelModal.propTypes = ExcelModalPropTypes


